jQuery(document).ready(function ($) {

    $(window).scroll(function () {
        var sticky = $('.header'),
            scroll = $(window).scrollTop();

        if (scroll >= 1) sticky.addClass('sticky');
        else sticky.removeClass('sticky');
    });

    $(".header__inner__nav__open").click(function () {
        $('.header').addClass("menu_active");
        $('body').addClass("toggle_menu_active");
    });

    $(".header__inner__nav__close").click(function () {
        $('.header').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
        if ($('.header__inner__nav__main div.parent').hasClass("open")) {
            $('.header__inner__nav__main div.parent button.submenu-toggle').removeClass("active");
            $('.header__inner__nav__main div.parent').removeClass("open");
            $('.header__inner__nav__main div.parent .header__inner__nav__main__col.children').slideUp();
        }
    });
    
    $('.header__inner__nav__main').find('div.parent > a').after('<button class="submenu-toggle"><svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.34209 4.97493C4.04935 5.4433 3.36722 5.4433 3.07449 4.97493L0.685969 1.15329C0.374839 0.655486 0.732729 0.00976536 1.31977 0.00976541L6.09681 0.00976581C6.68385 0.00976586 7.04174 0.655487 6.73061 1.15329L4.34209 4.97493Z" fill="#F2F1F6"/></svg></button>');
    $('body').on('click', ".header__inner__nav__main .parent > button.submenu-toggle", function (e) {
        if (jQuery(window).width() < 992) {
            e.preventDefault();
            if ($(this).parent().find(">.header__inner__nav__main__col.children").is(":hidden")) {
                $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
                $(this).parent().siblings().find('> .header__inner__nav__main__col.children').slideUp();
                $(this).parent().siblings().removeClass('open');
                $(this).addClass("active");
                $(this).parent().find('> .header__inner__nav__main__col.children').slideDown();
                $(this).parent().addClass("open");
            } else {
                $(this).removeClass("active");
                $(this).parent().find('> .header__inner__nav__main__col.children').slideUp();
                $(this).parent().removeClass("open");
            }
        }
    });

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
        if (jQuery(".contact_popup.open").length > 0) {
            jQuery(".contact_popup.open .contact_popup__form_inner").hide();
            jQuery(".contact_popup.open .contact_popup__related").show();
            if (jQuery(".contact_popup.open .gform_confirmation_message").length > 0) {
                var html1 = jQuery(".contact_popup.open .gform_confirmation_message").html();
                jQuery(".contact_popup.open .contact_popup__updaedText").html(html1);
            }
        }
    });
});